import React, { useState } from 'react'
import { Button, Card, DatePicker, Form, Input, notification, Select } from 'antd'
import { getApi } from '../../../api/getApi'
import { useHistory } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { ApiError } from '../../../api/apiError/apiError'
import { Moment } from 'moment/moment'

const EMAIL_REGEXP = /^[A-Z0-9._%+-]+@(appscience\.ru|conc\.ru)$/i
const INTEGER_REGEXP = /^[0-9]+$/i

type LetitPlanningFormState = {
  letitList: string[]
  oboDateRange: Moment[]
  email: string
}

const { RangePicker } = DatePicker

export const LetitPlanningView: React.FC = () => {
  const history = useHistory()
  const [form] = Form.useForm<LetitPlanningFormState>()
  const [letitListRequired, setLetitListRequired] = useState<boolean>(false)
  const [oboDateRequired, setOboDateRequired] = useState<boolean>(false)

  const isEveryStringNumber = (arr: string[]): boolean =>
    arr.every(item => INTEGER_REGEXP.test(item)) // Check if the string is a valid number

  const sendLetitPlanningRequest = (formData: LetitPlanningFormState) => {
    const letitNumsList = formData.letitList ? formData.letitList.map(Number) : []
    const oboDateFrom = formData.oboDateRange ? formData.oboDateRange[0].format('YYYY-MM-DD') : ''
    let oboDateTo = formData.oboDateRange ? formData.oboDateRange[1].format('YYYY-MM-DD') : ''

    // if from and to equals to one date, leave only first date for exact date query
    oboDateTo = oboDateFrom == oboDateTo ? '' : oboDateTo

    getApi()
      .proposal
      .letitPlanning({
        letitList: letitNumsList,
        registerOboDateFrom: oboDateFrom,
        registerOboDateTo: oboDateTo,
        email: formData.email,
      })
      .then(() => {
        notification.success({
          message: `Успешно`,
          description: 'Запрос успешно отправлен',
        })
        setTimeout(() => { //TODO change to appropriate form clear
          history.go(0)
        }, 1000)
      })
      .catch((error: ApiError) => {
        notification.error({
          message: 'Ошибка при отправке запроса',
          description: error.getRuText?.() || error.message,
          duration: 10,
        })
        Sentry.captureException(error)
      })
  }

  const onFormDataChange = (changedValues = {}, { letitList, oboDateRange}: LetitPlanningFormState) => {
    if (letitList && letitList.length > 0) {
      setLetitListRequired(true)
      setOboDateRequired(false)
      return
    }

    if (oboDateRange && oboDateRange.length > 0) {
      setLetitListRequired(false)
      setOboDateRequired(true)
      return
    }

    setLetitListRequired(false)
    setOboDateRequired(false)
  }

  return <>
    <Card>
      <Form
        form={form}
        name='basic'
        initialValues={{
          letitList: [],
          email: '',
        }}
        onFinish={sendLetitPlanningRequest}
        onValuesChange={onFormDataChange}
      >
        <Form.Item
          label='Список Летит номеров'
          name='letitList'
          rules={[
            {
              required: letitListRequired,
              message: 'Неправильный Летит номер',
              validator: (_, value) => {
                console.log(value)
                if (!isEveryStringNumber(value)) {
                  return Promise.reject('Неправильный Летит номер')
                }
                return Promise.resolve()
              },
            },
          ]}
        >
          <Select
            disabled={oboDateRequired}
            mode='tags'
            style={{ width: '100%' }}
            tokenSeparators={[',']}
            open={false}
          />
        </Form.Item>

        <Form.Item
          label='Дата приёмки, c'
          name='oboDateRange'
          rules={[
            {
              required: oboDateRequired,
            },
          ]}
        >
          <RangePicker disabled={letitListRequired} format={'DD.MM.YYYY'}/>
        </Form.Item>

        <Form.Item
          label='E-mail для ответа (опционально)'
          name='email'
          rules={[
            {
              message: 'Неправильный рабочий e-mail!',
              validator: (_, value) => {
                if (value === '') {
                  return Promise.resolve()
                }

                if (EMAIL_REGEXP.test(value)) {
                  return Promise.resolve()
                }

                return Promise.reject('Неправильный рабочий e-mail!')
              },
            },
          ]}
        >
          <Input placeholder='Введите рабочий e-mail'/>
        </Form.Item>

        <Button
          type='primary'
          htmlType='submit'
        >
          Отправить запрос
        </Button>
      </Form>
    </Card>
  </>
}